/* eslint-disable no-console */
import { Num } from '@/helpers/Math.js'
import db from '@/lib/IndexedDB'
import * as CONST from '@/constants.js'
import * as utils from '@/utils/main_utils'

export const Item = {
  getIndex(state) {
    if (!state.items || !state.items.length) {
      return 0
    }
    let index = -1
    state.items.forEach((item) => {
      if (item.index > index) {
        index = item.index
      }
    })
    return ++index
  },
  itemNetPrice(item, round = false) {
    const val = item.value / ((100 + item.tax_sum) / 100)
    return round ? Num.round(val) : val
  },
  netPrice(fullPrice, taxSum, round = false) {
    const val = fullPrice / ((100 + taxSum) / 100)
    return round ? Num.round(val) : val
  },
  itemTax(item) {
    return (item.netPrice * item.tax_sum) / 100
  },
  prepare(state, item) {
    item.split = undefined
    item.paid = undefined
    if (typeof item.index === 'undefined') {
      item.index = this.getIndex(state)
    }
    item.note = item.note || undefined
    item.quantity = item.quantity || 1
    return item
  },
  async saveCart(state) {
    db.setStore('store')
    return db.update({ key: 'cart', items: state.items })
  },
  async clearCart() {
    db.setStore('store')
    return db.delete('cart')
  },
  async resotreCart() {
    db.setStore('store')
    return new Promise((resolve, reject) => {
      db.find('cart').then((data) => {
        if (data) {
          resolve(data.items)
        } else {
          reject()
        }
      })
    })
  },
  tax(netPrice, taxSum, round = false) {
    const realTax = netPrice * taxSum * 0.01
    return round ? Num.round(realTax) : realTax
  },
  //this is used for display, not used for cart calculations
  // eslint-disable-next-line no-unused-vars
  applyMenuDiscounts(item) {
    if (item.menuDiscounts.length) {
      let itemDiscountedPrice = item.value

      item.menuDiscounts = item.menuDiscounts.map((discount) => {
        if (
          discount.type === CONST.DISCOUNT_TYPE_FIXED_PRICE &&
          item.value > discount.value &&
          itemDiscountedPrice - discount.value >= 0
        ) {
          //real
          let grossPrice = item.value - discount.value

          //decrease by discount, to check if it goes below 0
          itemDiscountedPrice -= grossPrice

          discount.price = this.netPrice(grossPrice, item.tax_sum)
          discount.tax = this.tax(discount.price, item.tax_sum)

          //rounding
          discount.rounded = {
            price: this.netPrice(grossPrice, item.tax_sum, true),
          }
          discount.rounded.tax = this.tax(
            discount.rounded.price,
            item.tax_sum,
            true
          )
          return discount
        } else if (
          discount.type === CONST.DISCOUNT_TYPE_VALUE &&
          item.value >= discount.value &&
          itemDiscountedPrice - discount.value >= 0
        ) {
          discount.price = discount.value
          itemDiscountedPrice -= discount.price
          //either apply disocunt and then calculate tax on item
          //or apply disocunt on tax, I would prefer first one
          //https://www.sabauditing.ae/vat-on-discounted-price-in-uae/
          discount.tax =
            item.tax - this.tax(item.netPrice - discount.price, item.tax_sum)
          //rounded
          discount.rounded = {
            price: discount.price,
            //we need to subtract the rounded discounted price as we ll be
            //sending this rounded price to api
            tax:
              item.rounded.tax -
              Num.round(
                this.tax(item.rounded.netPrice - discount.price, item.tax_sum)
              ),
          }
          return discount
        } else if (
          discount.type === CONST.DISCOUNT_TYPE_PERCENTAGE &&
          item.value > 0
        ) {
          discount.price = item.netPrice * discount.rate * 0.01

          if (itemDiscountedPrice - discount.price >= 0) {
            itemDiscountedPrice -= discount.price
            //either apply disocunt and then calculate tax on item
            //or apply disocunt on tax, I would prefer first one
            //https://www.sabauditing.ae/vat-on-discounted-price-in-uae/
            discount.tax =
              item.tax - this.tax(item.netPrice - discount.price, item.tax_sum)
            //rounded
            discount.rounded = {
              price: Num.round(item.rounded.netPrice * discount.rate * 0.01),
              //we need to subtract the rounded discounted price as we ll be
              //sending this rounded price to api
              tax:
                item.rounded.tax -
                Num.round(
                  this.tax(item.rounded.netPrice - discount.price, item.tax_sum)
                ),
            }
            return discount
          }
        }
      })
    }
    item.menuDiscounts = item.menuDiscounts.filter((discount) => discount)
    return item
  },
  //this func is used only for cart calculations, due to differences of line item
  //we may have some items which don't support the discount when we perform actual calculations, so we ll
  // remove them based on quantity, cart discounts ll be source of truth
  cartCalculations(item, getters) {
    //counter if there is not netPrice
    if (!item.netPrice) {
      return false
    }
    //this is value calculated based on quantity + discount, in termsof line item

    if (item.item_type !== 'combo_item') {
      item.additionalNetPrice = getters.item_modifiers_net_price(item)
    } else {
      item.additionalNetPrice =
        getters.combo_item_modifiers_price(item).net_price
    }

    item.additionalTax = getters.item_modifiers_tax(item)
    item.additionalTaxRounded = getters.item_modifiers_tax_rounded(item)

    item.collectiveNetPrice = item.netPrice + item.additionalNetPrice
    item.collectiveNetPriceRounded = Num.add(
      item.rounded ? item.rounded.netPrice : item.netPrice,
      item.additionalNetPrice
    )
    item.collectiveTax = item.tax + item.additionalTax
    item.collectiveTaxRounded = Num.add(
      item.rounded.tax,
      item.additionalTaxRounded
    )

    const totalCollectiveNetPrice = item.collectiveNetPrice * item.quantity
    const totalCollectiveTax = item.collectiveTax * item.quantity
    let itemCartDiscounts = []
    if (item.menuDiscounts.length) {
      item.menuDiscounts.forEach((discount) => {
        switch (discount.type) {
          case CONST.DISCOUNT_TYPE_FIXED_PRICE:
            if (discount.value < item.value) {
              let grossPrice = item.value - discount.value
              discount.price = this.netPrice(grossPrice, item.tax_sum)
              discount.tax = this.tax(discount.price, item.tax_sum)

              //rounding
              discount.rounded = {
                price: this.netPrice(grossPrice, item.tax_sum, true),
              }
              discount.rounded.tax = this.tax(
                discount.rounded.price,
                item.tax_sum,
                true
              )

              discount.price = discount.price * item.quantity
              discount.tax = discount.tax * item.quantity
              discount.rounded.price = discount.rounded.price * item.quantity
              discount.rounded.tax = discount.rounded.tax * item.quantity
              itemCartDiscounts.push(discount)
            }
            break
          case CONST.DISCOUNT_TYPE_VALUE:
            if (discount.value <= totalCollectiveNetPrice) {
              discount.price = discount.value
              //https://www.sabauditing.ae/vat-on-discounted-price-in-uae/
              discount.tax =
                totalCollectiveTax -
                this.tax(totalCollectiveNetPrice - discount.price, item.tax_sum)
              //rounded
              discount.rounded = {
                price: discount.price,
                tax:
                  Num.round(totalCollectiveTax) -
                  Num.round(
                    this.tax(
                      totalCollectiveNetPrice - discount.price,
                      item.tax_sum
                    )
                  ),
              }
              itemCartDiscounts.push(discount)
            }
            break
          case CONST.DISCOUNT_TYPE_PERCENTAGE:
            if (item.collectiveNetPrice > 0) {
              discount.price = item.netPrice * discount.rate * 0.01
              //https://www.sabauditing.ae/vat-on-discounted-price-in-uae/
              discount.tax =
                item.tax -
                this.tax(item.netPrice - discount.price, item.tax_sum)
              //rounded
              const roundedTax = this.tax(
                item.netPrice - discount.price,
                item.tax_sum,
                true
              )

              discount.rounded = {
                price: Num.round(item.rounded.netPrice * discount.rate * 0.01),
                //we need to subtract the rounded discounted price as we ll be
                //sending this rounded price to api
                tax: Num.sub(item.rounded.tax, roundedTax),
              }
              discount.price = discount.price * item.quantity
              discount.tax = discount.tax * item.quantity
              discount.rounded.price = discount.rounded.price * item.quantity
              discount.rounded.tax = discount.rounded.tax * item.quantity

              itemCartDiscounts.push(discount)
            }
            break
        }
      })
    }
    item.cartDiscounts = itemCartDiscounts
    //this ll get you the item collective price * item .qty to show on cart subtotal (inc tax)
    item.collectivePrice = getters.item_discounted_collective_cart_price(item)
    return item
  },
  isEmptyObject(obj) {
    return !Object.keys(obj).length
  },
  restoreItemData(oitem, sourceItem, getters) {
    const item = { ...oitem }
    const itemIndex = sourceItem.no
    const selectedOrder = getters.selected_order || undefined
    let itemModifiers = undefined
    //checked empty object because on reload item was lost from cart
    if (!this.isEmptyObject(selectedOrder)) {
      let selectedOrderModifiers = selectedOrder.item_modifiers
      if (selectedOrderModifiers.length) {
        itemModifiers = []
        for (let item in selectedOrderModifiers) {
          let itemModifier = selectedOrderModifiers[item]
          if (itemModifier.for_item === itemIndex) {
            let modifierEntity = getters.find_item_modifier_by_main_id(
              itemModifier.entity_id
            )
            let modifierType = ''
            //we may lose the data from collection as we move back to homepage where there is no store id
            if (modifierEntity) {
              modifierType = getters.find_item_modifier_subgroup_by_main_id(
                modifierEntity.modifier_sub_group
              ).item_type
            }
            const modifier = {
              ...modifierEntity,
              type: modifierType,
            }
            itemModifiers.push(modifier)
          }
        }
      }
    }
    item.index = sourceItem.index || itemIndex
    item.quantity = sourceItem.quantity || sourceItem.qty
    item.modifiers = itemModifiers || sourceItem.modifiers
    item.store_id = sourceItem.store_id
    item.brand_id = sourceItem.brand_id
    if (
      !this.isEmptyObject(selectedOrder) &&
      !item.store_id &&
      !item.brand_id
    ) {
      item.brand_id = selectedOrder.brand_id || undefined
      item.store_id = selectedOrder.store_id || undefined
    }
    //don't prepare it
    return item
  },
  makeApiRequest(getters, dispatch) {
    const orderTime = utils.date_time_utc()
    let order_type = getters.order_type
    let order_covers = undefined
    let cover = getters.defaultSelectedCover

    if (getters.isFloorTableAvailable.table_id) {
      // will remove soon
      order_type = CONST.ORDER_TYPE_DINEIN
      if (cover) {
        order_covers = [{ entity_id: cover._id, name: cover.name }]
      }
    }
    let order = {
      //do not send transition order no with goorder or ecommerce site, it should not be validated at backend
      transition_order_no: '',
      currency: getters.currentStore.currency /* will set dynamic later*/,
      order_status: CONST.ORDER_STATUS_IN_PROGRESS,
      order_source: getters.order_source,
      order_type: order_type,
      order_mode: CONST.ORDER_MODE_ONLINE,
      real_created_datetime: orderTime,
      // order_mode: 'online',
      //remove the modifiers prices from subtotal
      customer: getters.web_user ? getters.web_user.id : '',
      go_order_customer: getters.go_order_customer_id,

      customer_address_id: '',

      order_building: '',
      order_street: '',
      order_flat_number: '',
      order_nearest_landmark: '',
      order_city: '',
      order_country: '',
      order_delivery_area: '',

      referral: '',

      item_discounts: [],
      item_modifiers: [],
      order_surcharges: [],
      order_discounts: [],
      order_payments: [],
      items: [],
      sub_total: Num.round(getters.cart_net_sub_total),
      total_surcharge: getters.order_surcharge_total,
      surcharge_tax: getters.order_surcharge_tax,
      total_discount: getters.net_discount_on_order,
      total_tax: Num.round(
        Num.add(getters.cart_sub_total_tax, getters.order_surcharge_tax) -
          getters.tax_discount_on_order
      ),
      total_paid: Num.round(getters.order_total),
      balance_due: Num.round(getters.order_total - getters.driver_tip),
      tip_amount: getters.driver_tip,
      print_count: 0,
      amount_changed: 0,
      order_note: getters.order_note || '',
      order_address_instructions: getters.order_address_instructions || '',
      delivery_surcharge: getters.delivery_surcharge || 0,
    }
    if (getters.order_id && order_type != 'online') {
      delete order.real_created_datetime
      order.table_reservation_id = getters.selected_order.table_reservation_id
    }
    if (getters.currentBrand.number_of_covers && order_covers) {
      order.covers = order_covers
    }
    if (getters.customer_address) {
      order.customer_address_id = getters.customer_address._id
        ? getters.customer_address._id['$oid']
        : ''

      order.order_building = getters.customer_address.building
      order.order_street = getters.customer_address.street
      order.order_flat_number = getters.customer_address.flat_number
      order.order_nearest_landmark = getters.customer_address.nearest_landmark
      order.order_city = getters.customer_address.delivery_area_id.split('|')[1]
      order.order_country =
        getters.customer_address.delivery_area_id.split('|')[2]
      order.order_delivery_area = getters.customer_address.delivery_area_id
    }
    if (getters.reservationsData) {
      order.table_reservation_id = getters.reservationsData
      order.order_action_history = []
    }
    console.log('cart_net_sub_total', getters.cart_net_sub_total)
    console.log('order_surcharge_total', getters.order_surcharge_total)
    console.log('order_surcharge_tax', getters.order_surcharge_tax)
    console.log('net_discount_on_order', getters.net_discount_on_order)
    console.log('order_total', getters.order_total)
    console.log('cart_sub_total_tax', getters.cart_sub_total_tax)
    console.log('order_surcharge_tax', getters.order_surcharge_tax)
    console.log('tax_discount_on_order', getters.tax_discount_on_order)
    console.log(
      'total_cart_item_discount_tax',
      getters.total_cart_item_discount_tax
    )
    if (getters.future_order_format_date_time) {
      order.future_order_datetime = getters.future_order_format_date_time
    }

    getters.available_cart_items.forEach((item) => {
      console.log('item price', item.rounded.netPrice)
      console.log('item tax', item.rounded.tax)
      // order.covers.push
      if (
        getters.currentBrand &&
        order_covers &&
        getters.currentBrand.number_of_covers
      ) {
        order.items.push({
          name: item.name,
          cover_name: order_covers[0].name,
          cover_no: order_covers[0].entity_id,
          entity_id: item._id,
          no: item.index,
          status: 'in-progress',
          tax: item.rounded.tax,
          price: item.rounded.netPrice,
          qty: item.quantity,
          type: item.item_type,
          for_combo: false,
          note: item.note || undefined,
        })
      } else {
        order.items.push({
          name: item.name,
          entity_id: item._id,
          no: item.index,
          status: 'in-progress',
          tax: item.rounded.tax,
          price: item.rounded.netPrice,
          qty: item.quantity,
          type: item.item_type,
          for_combo: false,
          note: item.note || undefined,
        })
      }
      if (item.item_type === CONST.ITEM_TYPE_COMBO) {
        item.combo_selected_items.forEach((cmb_item) => {
          order.items.push({
            name: cmb_item.name,
            entity_id: cmb_item._id,
            no: cmb_item.index,
            status: 'in-progress',
            tax: cmb_item.tax,
            price: Num.round(cmb_item.netPrice),
            qty: cmb_item.quantity,
            type: cmb_item.item_type,
            for_combo: cmb_item.for_combo,
            note: cmb_item.note || undefined,
          })
          if (cmb_item.modifiers && cmb_item.modifiers.length) {
            cmb_item.modifiers.forEach((modifier) => {
              order.item_modifiers.push({
                entity_id: modifier._id,
                for_item: cmb_item.index,
                price: modifier.value || 0,
                tax: this.tax(modifier.value, cmb_item.tax_sum),
                name: modifier.name,
                qty: cmb_item.quantity,
                type: modifier.type,
              })
            })
          }
        })
      }
      if (item.cartDiscounts.length) {
        item.cartDiscounts.forEach((discount) => {
          if (typeof discount.price !== 'undefined') {
            order.item_discounts.push({
              name: discount.name,
              type: discount.type,
              rate:
                discount.type === CONST.DISCOUNT_TYPE_VALUE
                  ? discount.value
                  : discount.rate,
              price: discount.rounded.price,
              tax: discount.rounded.tax,
              for_item: item.index,
              entity_id: discount._id,
            })
          }
        })
      }

      if (item.modifiers && item.modifiers.length) {
        item.modifiers.forEach((modifier) => {
          order.item_modifiers.push({
            entity_id: modifier._id,
            for_item: item.index,
            price: modifier.value || 0,
            tax: this.tax(modifier.value, item.tax_sum, true),
            name: modifier.name,
            qty: item.quantity,
            type: modifier.type,
          })
        })
      }
    })

    getters.order_surcharges.forEach((surcharge) => {
      order.order_surcharges.push({
        entity_id: surcharge.entity._id,
        name: surcharge.entity.name,
        type: surcharge.entity.type,
        price: surcharge.surcharge,
        rate: surcharge.entity.rate,
        tax: surcharge.tax,
        tax_rate: surcharge.entity.tax_sum,
        taxable: surcharge.entity.tax_sum ? true : false,
      })
    })

    getters.discounts_on_order_breakdown.forEach((discount) => {
      order.order_discounts.push({
        name: discount.entity.name,
        price: discount.price,
        tax: discount.tax,
        type: discount.entity.type,
        rate:
          discount.entity.type === CONST.DISCOUNT_TYPE_VALUE
            ? discount.entity.value
            : discount.entity.rate,
        include_surcharge: discount.entity.include_surcharge,
        entity_id: discount.entity._id,
      })
    })
    const order_payments = getters.payment_params(Num.round(order.total_paid))

    //set guest info
    if (getters.guest_checkout) {
      order.guest_checkout = true
      order.guest_customer = {
        name: getters.guest_info.name,
        email: getters.guest_info.email,
        phone_number: getters.guest_info.phone
          .toString()
          .replace(/\+/g, '')
          .replace(/\s/g, ''),
      }
      // setting oneSignal email for Push notification
      window.OneSignal.push(function () {
        if (getters.guest_info.email) {
          let phone_number = getters.guest_info.phone
            .toString()
            .replace(/\+/g, '')
            .replace(/\s/g, '')
          var notificationId = getters.guest_info.email.trim() || phone_number
          window.OneSignal.setExternalUserId(notificationId)
          dispatch(
            'updateExternalHandler',
            'js-call:set-email:' + notificationId
          )
        }
      })
      order.customer = ''
      order.customer_address_id = ''
    }
    if (order_payments.length) {
      if (!getters.isFloorTableAvailable.table_id) {
        order.order_payments = order_payments
      }
      return Object.freeze(order)
    }
    return false
  },
  /*totalAmount(order) {
    if (order) {
      return parseFloat(order.tip_amount) + parseFloat(order.balance_due)
    }
    return 0
  },*/
  formErrorsToString(form_errors) {
    let error = ''
    for (let i in form_errors) {
      if (typeof form_errors[i] === 'string') {
        error += ' ' + form_errors[i]
      } else {
        error += i
        form_errors[i].forEach((err) => (error += ': ' + err))
      }
    }
    return error
  },
}
